import { Check } from "lucide-react";
import { PACKAGES } from "@/lib/data";
import { Reveal, Overline } from "@/components/Reveal";
import { scrollToId } from "@/components/Logo";

export default function Packages() {
  return (
    <section
      id="packages"
      className="relative py-24 sm:py-32 lg:py-40 bg-[var(--surface-subtle)]"
      data-testid="packages-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Reveal className="flex justify-center">
            <Overline testid="packages-overline">Investment</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight">
              Collections for every scale of love.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 text-[var(--ink-2)] font-light">
              Every celebration is bespoke. These collections are starting points — we tailor each to
              your story.
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {PACKAGES.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <div
                className={`relative h-full flex flex-col rounded-[3px] p-8 sm:p-10 border transition-all duration-500 ${
                  p.highlighted
                    ? "bg-[var(--ink)] text-[var(--bg)] border-[var(--ink)] lg:-translate-y-4 shadow-[0_40px_80px_-40px_rgba(35,31,32,0.6)]"
                    : "bg-[var(--surface)] border-[var(--border-gold)] hover:-translate-y-1"
                }`}
                data-testid={`package-card-${p.id}`}
              >
                {p.highlighted && (
                  <span className="absolute top-6 right-6 text-[10px] uppercase tracking-[0.25em] text-[var(--gold)]">
                    Signature
                  </span>
                )}
                <div className={`text-xs uppercase tracking-[0.2em] ${p.highlighted ? "text-[var(--gold)]" : "text-[var(--ink-3)]"}`}>
                  {p.note}
                </div>
                <h3 className="font-serif text-3xl mt-3">{p.name}</h3>
                <div className={`font-serif text-2xl mt-4 ${p.highlighted ? "text-[var(--gold)]" : "text-[var(--ink)]"}`}>
                  {p.price}
                </div>
                <ul className="mt-7 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm">
                      <Check size={16} className="text-[var(--gold)] shrink-0 mt-0.5" />
                      <span className={p.highlighted ? "text-[var(--bg)]/85" : "text-[var(--ink-2)]"}>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToId("contact")}
                  className={`mt-9 w-full rounded-full py-3.5 text-sm tracking-wide transition-colors duration-400 ${
                    p.highlighted
                      ? "bg-[var(--gold)] text-[var(--ink)] hover:bg-[var(--bg)]"
                      : "bg-[var(--ink)] text-[var(--bg)] hover:bg-[var(--gold)]"
                  }`}
                  data-testid={`package-cta-${p.id}`}
                >
                  Enquire Now
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
